import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Provider } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import configureStore from 'stores/configureStore';
import MentoringClassStatus from 'components/mentoring/MentoringClassStatus';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { rejectMentoringClass } from 'libs/api/mentoring';
import { TMentoringReject } from 'modules/mentoring';
import { TModalProps } from 'modules/types';
import { Modal, Input, Button, Row, Typography, Form } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FormWrapper } from 'GlobalStyles';

const { Text, Title } = Typography;

const MentoringRejectModal = ({ modalState, setModalState }: TModalProps) => {
  //props로 전달받은 modalState에서 해당 멘토링 record.id 값만 뽑아옴
  const mentoringClassId = get(modalState, 'record.id');
  //버튼 눌렀을 때 모달 취소, 혹은 수업 취소 처리할 때까지 true => 로딩되는 것처럼 보여지도록
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  //antd Form태그 쓸 때
  const [form] = Form.useForm();
  //현재 유저의 state 리덕스로 관리
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const store = configureStore({});
  // const getPromise = getMentoringClass.bind(null, mentoringClassId);
  // const [{ data, loading }, setCallback] = useDataApi<TMentoringClass>(
  //   getPromise
  // );

  function handleSubmit() {
    //value는 {memo:string} 형태
    async function handleMentoringReject(value: TMentoringReject) {
      try {
        setSubmitButtonDisabled(true);
        //엔드 포인트 POST
        await rejectMentoringClass(mentoringClassId, value);
        modalState.onFinish && modalState.onFinish();
        handleCancel();
      } catch (e) {
        handleFieldError(e, form);
        throw e;
      } finally {
        //에러 없거나 멘토링 거절하기 작업 모두 끝났으면 버튼 로딩 끝!!
        setSubmitButtonDisabled(false);
      }
    }
    form
      .validateFields()
      .then((value) => {
        handleMentoringReject(value as TMentoringReject);
      })
      .catch((errorInfo) => {
        moveToFirstError(form, errorInfo.errorFields);
      });
  }

  function handleCancel() {
    setModalState({ visible: false });
    form.resetFields();
  }

  return (
    <Modal
      visible={modalState.visible}
      maskClosable={true}
      closable={false}
      footer={
        <Row justify='end'>
          <Button onClick={handleCancel}>취소</Button>
          <Button danger loading={submitButtonDisabled} onClick={handleSubmit}>
            거절하기
          </Button>
        </Row>
      }
      width={680}
      centered={true}
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: '10px 0 -25px 0',
          }}
        >
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '22px' }} />
          <span style={{ fontWeight: 'bold', marginLeft: '20px' }}>거절하기</span>
        </div>
      }
      onCancel={handleCancel}
    >
      {/* content */}
      <Provider store={store}>
        <MentoringClassWrapper style={{ padding: '0px 33px' }}>
          <MentoringClassStatus record={modalState.record} />

          <div style={{ marginTop: '10px' }}>
            <img
              alt='profile_image'
              className='small-thumbnail-img'
              src={get(modalState.record, 'mentee.user.profile_image.absolute_url')}
            />
            <span style={{ marginLeft: '5px' }}>{get(modalState.record, 'mentee.user.fullname')} 멘티</span>
          </div>

          <form style={{ marginTop: '15px' }}>
            멘토링 신청을 거절하시겠습니까?
            <FormWrapper style={{ padding: '20px 0px' }}>
              <Form form={form} layout='vertical' className='form-normal'>
                <Form.Item
                  name='memo'
                  className='form-item no-margin'
                  label='거절 사유를 적어주세요'
                  rules={[{ required: true }]}
                >
                  <Input.TextArea
                    className='form_textarea'
                    placeholder='거절사유를 자세하게 적어주세요.
예) 이번 시간이 적합하지 않아서 수업이 진행이 다소 어렵습니다. 홍길동님의 양해를 구합니다.'
                    autoSize={{ minRows: 5 }}
                  />
                </Form.Item>
              </Form>
            </FormWrapper>
          </form>
        </MentoringClassWrapper>
      </Provider>
    </Modal>
  );
};

export default MentoringRejectModal;
